import { useEffect, useState } from 'react';

import { type ExtendedAirgapAPI, type ExtendedTranscendAPI } from '../types';

import { TRANSCEND_LOAD_EVENT_NAME } from '@/modules/consent/constants';

export function useConsentManager() {
  const [readyAirgap, setReadyAirgap] = useState<
    ExtendedAirgapAPI | undefined
  >();
  const [readyTranscend, setReadyTranscend] = useState<
    ExtendedTranscendAPI | undefined
  >();
  const [airgapLoadedEvent, setAirgapLoadedEvent] = useState<Event | undefined>(
    undefined
  );

  function loadTranscend() {
    const interval = setInterval(() => {
      // initially the object is the script element itself
      // so checking for the ready property
      // means we have the actual client object
      if (window.transcend?.ready) {
        clearInterval(interval);
        window.transcend.ready(() => setReadyTranscend(window.transcend));
        return window.transcend;
      }
    }, 10);
  }
  function loadAirgap() {
    const interval = setInterval(() => {
      // initially the object is the script element itself
      // so checking for the ready property
      // means we have the actual client object
      if (window.airgap?.ready) {
        clearInterval(interval);
        window.airgap.ready(() => setReadyAirgap(window.airgap));
        return window.airgap;
      }
    }, 10);
  }

  function resetAirgapConsent() {
    if (window._TRANSCEND_LOAD_EVENT) {
      window.airgap?.reset(window._TRANSCEND_LOAD_EVENT, false);
    }
  }

  useEffect(() => {
    function handleLoad(e: CustomEvent) {
      setAirgapLoadedEvent(e.detail.event);
    }
    loadTranscend();
    loadAirgap();
    window.addEventListener(TRANSCEND_LOAD_EVENT_NAME, handleLoad);

    return () => {
      window.removeEventListener(TRANSCEND_LOAD_EVENT_NAME, handleLoad);
    };
  }, []);

  return {
    airgap: readyAirgap,
    transcend: readyTranscend,
    airgapLoadedEvent,
    resetAirgapConsent,
  };
}
